import { get } from 'lodash/fp'
import { Flex, Box } from 'rebass'
import styled from 'styled-components'

import createNumberInput from 'e-submission/components/Form/Input/NumberInput'

import createDropdown from './index'

const UNITS = [
  {
    text: 'วัน',
    value: 'day',
  },
  {
    text: 'สัปดาห์',
    value: 'week',
  },
  {
    text: 'เดือน',
    value: 'month',
  },
  {
    text: 'ปี',
    value: 'year',
  },
]

const BoxContainer = styled(Box)`
  & + & {
    margin-left: 0.5rem;
  }
`

const NumberInput = createNumberInput(({ value, onChange }) => {
  return {
    value,
    onChange,
  }
})
const Dropdown = createDropdown(({ value, onChange }) => {
  return {
    value,
    onChange,
  }
})

export const Component = ({ validate, setValue, placeHolder, value }) => {
  const unit = get('unit', value)
  const number = get('value', value)

  const onTextBoxChange = (month) => (year) => {
    setValue({
      year,
      month,
    })
  }

  const onDropdownChange = (year) => (month) => {
    setValue({
      year,
      month,
    })
  }

  return (
    <Flex>
      <BoxContainer flex="1 1 100%">
        <NumberInput validate={validate} format={'###'} value={number} setValue={onTextBoxChange(unit)} />
      </BoxContainer>
      <BoxContainer flex="1 1 100%">
        <Dropdown placeHolder={placeHolder} value={unit} options={UNITS} setValue={onDropdownChange(number)} />
      </BoxContainer>
    </Flex>
  )
}

export default (hoc) => Component
